import React from 'react';
import styled from 'styled-components';
import { ActionButton, typographyPresets } from '@agilepoint/wat-react-ux';
import { memoizeFunction } from '@agilepoint/utils-common';

interface IInitialsColorCodes {
    backgroundColor: string;
    textColor: string;
}

const COLORCODES = [{
    backgroundColor: '#DDECF7',
    textColor: '#0077D9'
}, {
    backgroundColor: '#ECE5F6',
    textColor: '#6E40CF'
}, {
    backgroundColor: '#F5E2EE',
    textColor: '#B32181'
}, {
    backgroundColor: '#DFEEE5',
    textColor: '#008334'
}, {
    backgroundColor: '#F4E6E6',
    textColor: '#B6383E'
}, {
    backgroundColor: '#F5EDDE',
    textColor: '#B96E02'
}, {
    backgroundColor: '#EFE1ED',
    textColor: '#8C007E'
}, {
    backgroundColor: '#EAEBEC',
    textColor: '#5F6672'
}, {
    backgroundColor: '#EFE8E0',
    textColor: '#934F00'
}, {
    backgroundColor: '#E4EAEE',
    textColor: '#19628F'
}, {
    backgroundColor: '#DEEDEE',
    textColor: '#00828C'
}, {
    backgroundColor: '#E3EAF5',
    textColor: '#165DCB'
}] as IInitialsColorCodes[];

const chooseRandomColors = memoizeFunction((name: string): IInitialsColorCodes => {
    const idx = Math.floor(Math.random() * COLORCODES.length);
    return COLORCODES[idx];
}, 500);

export interface IUserAvatarTextProps {
    userFullName: string;
    profileImage?: string;
}

const ShortName = styled(ActionButton) <{ $backgroundColor: string; $textColor: string; $profileImage?: string }>`
    color: ${({ $textColor }) => $textColor};
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    background-image: ${({ $profileImage }) => `${$profileImage || $profileImage !== '' ? `url(${$profileImage})` : 'none'}`};
    background-repeat: no-repeat;
    background-size: contain;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    text-align: center;
    text-transform: uppercase;

    .ap-button-label {
        ${typographyPresets.textStyles.xSmall};
        margin: 0;
    }
`;

export const UserAvatarText = React.memo((props: IUserAvatarTextProps) => {
    const { userFullName = '', profileImage, ...rest } = props;
    const abbrevatedText = React.useMemo(() => (userFullName.slice(0, 2)), [userFullName]);
    const { backgroundColor, textColor } = React.useMemo(() => chooseRandomColors(userFullName), [userFullName]);

    return (
        <ShortName
            $backgroundColor={backgroundColor}
            $textColor={textColor}
            $profileImage={profileImage}
            title={userFullName}
            label={profileImage ? '' : abbrevatedText}
            {...rest}
        />
    );
});
